import { i18nClient } from '@sailor/i18n-mach-pro/lib';
import { reduceStrArrToMap } from '@/src/utils';
import { logan, reportMetrics } from '@/src/pages/order/order_confirm_golden/monitor';
import { ERROR_CODE } from '@/src/pages/order/order_confirm_global/constant';
import { OrderRequest } from './interface';

import { hitAddressStrategy, homeSelectedUserAddress } from '../../utils/SLUserAddress';
import { convert2AddressInfo } from '../../utils/address/addressCovert';
import { AddressInfo } from '../../types/address';

export const ORDER_REQUEST_BODY = reduceStrArrToMap(['finParam']);
export const ORDER_RESPONSE_BODY = reduceStrArrToMap(['finRes']);

const indicatorModule = Mach.requireModule('ActivityIndicator');

export const TypeRequest = {
  PREVIEW: 0,
  UPDATE: 1,
  SUBMIT: 2
};

export const URL = {
  PREVIEW: 'v1/order/preview',
  UPDATE: 'v1/order/update',
  SUBMIT: 'v1/order/submit',
};

type ErrCodes = number[]

interface Options {
  showIndicator?: boolean;
}
/**
 *
 * @param orderRequest
 * @param type
 * @param errCodes 异常code数组，不走公共弹窗，单独处理异常逻辑
 * @param headers
 * @returns
 */
export async function orderRequest(orderRequest: OrderRequest, type = TypeRequest.PREVIEW, errCodes: ErrCodes = [], headers = {}, options: Options = {}): Promise<any> {
  // @ts-ignore
  const networkModule = Mach.requireModule('Network');
  const { showIndicator = true } = options;
  let url = URL.PREVIEW;
  if (type === TypeRequest.UPDATE) {
    url = URL.UPDATE;
    orderRequest.supportMap = {
      supportAddressOptimization: hitAddressStrategy() ? 1 : 0
    };
  } else if (type === TypeRequest.SUBMIT) {
    url = URL.SUBMIT;
  } else if (type === TypeRequest.PREVIEW) {
    orderRequest.supportMap = {
      supportAddressOptimization: hitAddressStrategy() ? 1 : 0
    };
  }
  let startTime = Date.now();
  const SLLocation = Mach.requireModule('SLLocation');
  const location = SLLocation?.getLocation();
  let duration = Date.now() - startTime;

  reportMetrics({
    OrderConfirmPerfBridgeGetLocation: duration
  }, {
    duration
  });
  orderRequest.latitude = location?.latitude;
  orderRequest.longitude = location?.longitude;
  orderRequest.actualLatitude = location?.actualLatitude;
  orderRequest.actualLongitude = location?.actualLongitude;
  orderRequest.orderSource = orderRequest.orderSource || 0;
  if (type === TypeRequest.PREVIEW) {
    // 提单页自动填写首页详细地址
    startTime = Date.now();
    const selectedUserAddress = homeSelectedUserAddress();
    duration = Date.now() - startTime;

    reportMetrics({
      OrderConfirmPerfBridgeHomeSelectedUserAddress: duration
    }, {
      duration
    });
    if (selectedUserAddress && selectedUserAddress.latitude && selectedUserAddress.longitude) {
      orderRequest.addressInfo = convert2AddressInfo(selectedUserAddress) as AddressInfo;
    }
    const addressInfo = orderRequest.addressInfo;
    if (addressInfo) {
      addressInfo.addressSnapshotCode = location?.detail?.addressSnapshotCode;
    }
  }

  // 需要 传入活动 id 与资源 id
  if (Mach.env?.schemeParams?.activity_id || Mach.env?.schemeParams?.resource_id) {
    const activityId = Mach.env?.schemeParams?.activity_id;
    const resourceId = Mach.env?.schemeParams?.resource_id;
    if (orderRequest.extra) {
      orderRequest.extra.activityId = activityId;
      orderRequest.extra.resourceId = resourceId;
    } else {
      orderRequest.extra = {
        activityId,
        resourceId
      };
    }
  }

  const params = {
    dataType: 'json',
    url,
    method: 'POST',
    params: null,
    data: {
      // machpro 包版本
      bundleVersion: Mach?.env?.bundleVersion,
      // machpro 包名称
      bundleName: Mach?.env?.bundleName ?? 'unknown',
      // 支持券包
      supportAp: true,
      ...orderRequest,
      tipsCustomAmountV2: orderRequest?.tipsCustomAmountV2?.toString() ?? '',
    },
    headers,
  };
  if (showIndicator) {
    // @ts-ignore
    indicatorModule.showLoading();
  }
  return new Promise<any>((resolve, reject) => {
    const startFetchTime = Date.now();

    networkModule.requestWx(params, (result: any) => {
      if (showIndicator) {
        indicatorModule.hideLoading();
      }

      const duration = Date.now() - startFetchTime;

      if (result.error) {
        reject(result.error);

        reportMetrics({
          OrderConfirmPageFetchAPIError: 1
        }, {
          url
        });

        logan({
          end: 'sideeffect',
          step: 'API fetch',
          data: {
            url,
            params: orderRequest,
            error: result.error,
            duration
          }
        });
      } else {
        reportMetrics({
          OrderConfirmPageFetchAPIError: 0
        }, {
          url,
          duration
        });

        const code = result?.data?.code;
        if (code === 0) {
          resolve({ traceId: result?.data?.traceId, ...result?.data?.data });
        } else {
          if (!result.data) {
            reject({ traceId: result?.data?.traceId, ...result?.data });
            return;
          }
          const errMsg = result?.data?.message;
          const showDialog = !errCodes.includes(code);
          const Dialog = Mach.requireModule('Dialog');
          showDialog && Dialog?.show({
            level: 1,
            title: errMsg || i18nClient.getText('shouye_default_4'),
            rightButtonTitle: i18nClient.getText('shop_cartlayer_clear2')
          }, (res: any) => {
            if (res.which === -1) {
              // 点击右边按钮
            } else if (res.which === -2) {
              // 点击左边按钮
            }
          });
          reject({ traceId: result?.data?.traceId, ...result?.data });
        }
      }
    });
  });
}
